export default [
  {
    name: 'testCom',
    path: '/testCom',
    meta: {
      title: '',
      href: '/testCom',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'testCom' */ '@/views/testCom/index')
  },
  {
    name: 'addCrossProject',
    path: '/addCrossProject',
    meta: {
      title: '',
      href: '/addCrossProject',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'addCrossProject' */ '@/views/main/myProject/crossProject/add')
    // }, {
    //   name: 'crossProjectDetail',
    //   path: '/crossProjectDetail',
    //   meta: {
    //     title: '',
    //     href: '/crossProjectDetail',
    //     redirect: 'noredirect'
    //   },
    //   component: () => import( /* webpackChunkName: 'addCrossProject' */ '@/views/main/crossProject/crossProjectDetail'),
  },
  {
    name: 'statisticsDetail',
    path: '/statisticsDetail',
    meta: {
      title: '任务统计详情',
      href: '/statisticsDetail',
      redirect: 'noredirect'
    },
    component: () => import(/* webpackChunkName: 'statisticsDetail' */ '@/views/statistics/statisticsDetail')
  },
]
